import React, {Component} from 'react'
import { MainHeader, MainFooter } from '../Components'

import firebase from '../Configs/firebase'

import './Css/PageLogin.css'


class ResetPassword extends Component{
    constructor(props){
        super(props)
        this.state = {
            email : ''
        }
    
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState(() => ({
            [name]: value
        }))
    }

    handleSubmit(event){
        event.preventDefault()
        const { email } = this.state
        firebase.auth().sendPasswordResetEmail(email)
        .then(()=>{
            alert('ส่ง Link สำหรับตั้งรหัสผ่านใหม่ไปที่ Email ของคุณเรียบร้อย กรุณาตรวจสอบและตั้งรหัสผ่านใหม่')
        })
    }

    render(){
        const { email } = this.state
        return (
                    <div className="InnerApp">
                        <MainHeader user={this.props.user}/>
                        <section className="UploadLanding hero">
                            <div className="hero-body"></div>
                        </section>
                        <section className="LoginForm section">
                            <div className="container">
                                <div className="box">
                                    <form onSubmit={this.handleSubmit}>
                                    <div className="field">
                                        <label className="label">Email</label>
                                        <div className="control">
                                            <input className="input is-rounded" type="text" onChange={this.handleChange} name='email' value={email} placeholder="email@mail.com"></input>
                                        </div>
                                    </div>
                                    <div className="divBtn">
                                        <input className="button is-primary is-rounded is-maxwidth" type="submit" value="ส่ง Email สำหรับเปลี่ยนรหัสผ่าน" />
                                    </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                        <MainFooter />            
                    </div>
                )
    }
}

export default ResetPassword


// WEBPACK FOOTER //
// ./src/PageLogin/_ResetPassword.js